import {BaseContainerModel} from '../base-container.model';
import {
  bl_prt_printable_format_list_hdr_RowInterface,
  bl_prt_printable_format_list_hdr_RowClass,
  bl_prt_printable_format_list_ext_RowClass
} from '../../dbschema/index';

export class PrintableFormatListContainerModel extends BaseContainerModel {
  bl_prt_printable_format_list_hdr: bl_prt_printable_format_list_hdr_RowInterface = new bl_prt_printable_format_list_hdr_RowClass();
  bl_prt_printable_format_list_exts: bl_prt_printable_format_list_ext_RowClass[] = [];
}
